import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputFile from '../../../FormFields/File';
import InputSelect from "../../../FormFields/Select";
import Checkbox from '../../../FormFields/Checkbox';
import Radio from '../../../FormFields/Radio';
import withConditionsAndTriggers from '../withConditionsAndTriggers';

export class FileImageWidget extends React.PureComponent {
  renderConfigTab = (internalField, changeFieldValue, changeFieldError) => {
    const {api,field} = this.props;
    return (
      <div className="Widget_Form_Config">
        <InputText label="Label" required value={api.getFieldsVerbiage(internalField, 'label')}
                   onChange={(v) => changeFieldValue('label', v)} error={internalField.errors['label']}
                   onError={(error) => changeFieldError('label', error)} />
        <InputText label="Description" value={api.getFieldsVerbiage(internalField, 'description')}
                   onChange={(v) => changeFieldValue('description', v)} />
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className="InputCheckboxesWrapper">
          <Radio onChange={() => changeFieldValue('image', false)} label="File" checked={!internalField.image}
                 className="InputCheckbox_Block" />
          <Radio onChange={() => changeFieldValue('image', true)} label="Photo" checked={internalField.image}
                 className="InputCheckbox_Block" />
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={(v) => changeFieldValue('labelInline', v)} label="Label inline"
                    checked={internalField.labelInline}
                    className="InputCheckbox_Block" />
          <Checkbox onChange={(v) => changeFieldValue('required', v)} label="Required"
                    checked={internalField.required}
                    className="InputCheckbox_Block" />
          <Checkbox onChange={(v) => changeFieldValue('notes', v)} label="Notes"
                    checked={internalField.notes}
                    className="InputCheckbox_Block" />
          <Checkbox onChange={(v) => changeFieldValue('lockDDR', v)} label="Lock in DDR"
                    checked={internalField.lockDDR}
                    className="InputCheckbox_Block" />
        </div>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={(v) => changeFieldValue('multiple', v)} label="Multiple"
                    checked={internalField.multiple}
                    className="InputCheckbox_Block" />
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, value, error, onChange, onError } = this.props;
    const { multiple, image, required, disabled } = field;
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfigTab),
      formTitle: 'File/Photo Input'
    };
    let className = 'FileWidget';
    let accept = '*';
    let placeholderFiles = multiple ? 'files' : 'file';
    if (image) {
      className = multiple ? 'MultiplePhotoWidget' : 'PhotoWidget';
      placeholderFiles = multiple ? 'photos' : 'photo';
      accept = 'image/*';
    }
    const placeHolder = 'Drag your ' + placeholderFiles + ' here or click to upload';
    return (
      <WrapperWidget {...props}>
        <div className={className}>
          <InputFile
            disabled={disabled}
            placeholder={placeHolder}
            required={required}
            multiple={multiple}
            accept={accept}
            value={value}
            onChange={onChange}
            onError={onError}
            error={error}
          />
        </div>
      </WrapperWidget>
    );
  }
}

export const FileImageWidgetEditable = withConditionsAndTriggers(FileImageWidget);
